import * as React from 'react'
import clx from 'classnames'

type Props = {
  className?: string
}


export const SkeletonBox = ({ className }: Props) => (
  <span
    aria-hidden="true"
    className={clx(
      'tw-block tw-animate-pulse tw-rounded tw-bg-gray-200',
      className,
    )}
  />
)
